import role from "./App-role";
// eslint-disable-next-line import/named
import { MODULE_ID } from "./CONSTANTS";
import { isElectronApp } from "../common/utils/electronAppHelper";

const Roles0 = [
  role.root,
  role.admin,
  role.developer,
  role.editor,
  role.reader,
].join(",");

const moduleSetting = {
  /* home page */

  /* sna page */
  // side toolbar
  [MODULE_ID.snaSidetoolGroup]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidetoolDataset]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidetoolDigitalAI]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidetoolAdjust]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidetoolFilter]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidetoolAnalytics]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidetoolHelp]: {
    isPublic: true,
    roles: Roles0,
  },
  // sidebar
  // groupTool
  [MODULE_ID.snaSidebarGroupAddmember]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarGroupEditmember]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarGroupsAddgroup]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarGroupsEditgroup]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  // fileTool
  [MODULE_ID.snaSidebarFile]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilePersonal]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilePersonalDatasetShare]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFileGroup]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFileGroupPublic]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFileGroupPrivate]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFileGroupPrivateEdit]: {
    isPublic: !isElectronApp(), // electron app 不開放
    roles: Roles0,
  },
  // adjustTool
  [MODULE_ID.snaSidebarAdjust]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustNodeColor]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustLinkColor]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustPlacement]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustNodeDispersion]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustNodeShowCount]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustApplySetting]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAdjustClearSetting]: {
    isPublic: false, // 不要顯示
    roles: Roles0,
  },
  // filterTool
  [MODULE_ID.snaSidebarFilter]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterNode]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterLink]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterTimePeriod]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterStartEndDate]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterNodeCountMeetAuth]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterApplySetting]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarFilterClearSetting]: {
    isPublic: true,
    roles: Roles0,
  },

  // analyticsTool
  [MODULE_ID.snaSidebarAnalytics]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAnalyticsCentrality]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAnalyticsGraphDensity]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaSidebarAnalyticsPageRank]: {
    isPublic: true,
    roles: Roles0,
  },

  // top panel
  [MODULE_ID.snaTopPanelImport]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelExport]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelExportFile]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelExportFileFormat]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelExportImage]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelExportImageFormat]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelExportImageResolution]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.snaTopPanelDataset]: {
    isPublic: true,
    roles: Roles0,
  },

  /* gis page */
  [MODULE_ID.gisPageLink]: {
    isPublic: false,
    roles: Roles0,
  },
  /* help page */
  [MODULE_ID.helpPageLink]: {
    isPublic: false,
    roles: Roles0,
  },
  // help basic
  [MODULE_ID.helpBasic]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicSignin]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicSignout]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicImport]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicExport]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicGroup]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicFile]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicAdjust]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicFilter]: {
    isPublic: true,
    roles: Roles0,
  },
  [MODULE_ID.helpBasicAnalytics]: {
    isPublic: true,
    roles: Roles0,
  },
  // help account
  [MODULE_ID.helpAccount]: {
    isPublic: true,
    roles: Roles0,
  },
  // help common
  [MODULE_ID.helpCommon]: {
    isPublic: true,
    roles: Roles0,
  },
  /* user setting */
  [MODULE_ID.userSettingPageLink]: {
    isPublic: false,
    roles: Roles0,
  },
  /* admin setting */
  [MODULE_ID.adminSettingPageLink]: {
    isPublic: false,
    roles: Roles0,
  },
  /* root setting */
  [MODULE_ID.rootSettingPageLink]: {
    isPublic: true,
    roles: Roles0,
  },
  /* shop page */
  [MODULE_ID.shopPageLink]: {
    isPublic: false,
    roles: Roles0,
  },
  /* privacy page */
  [MODULE_ID.privacyPageLink]: {
    isPublic: true,
    roles: Roles0,
  },
  /* service page */
  [MODULE_ID.servicePageLink]: {
    isPublic: true,
    roles: Roles0,
  },
};

export default moduleSetting;
